// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"install-pwa-prompt_wrapper__4UU3t"};